var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpRightGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 21 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.125 5.12v8.125a.625.625 0 0 1-1.25 0V6.63l-8.933 8.933a.625.625 0 1 1-.884-.884l8.933-8.933H7.375a.625.625 0 0 1 0-1.25H15.5a.625.625 0 0 1 .625.625"
})));
export default SvgArrowUpRightGrey;